import './utils/translateFix';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { OidcProvider } from 'redux-oidc';

import '@storaensods/se-design-system/dist/css/styles.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import i18n from './i18n';
import store from './store';
import userManager from './utils/userManager';

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <OidcProvider userManager={userManager} store={store}>
        <App />
      </OidcProvider>
    </Provider>
  </I18nextProvider>,
  document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
